// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"b016d39c","242":"c651ec82","351":"31d6cfe0","386":"2b227f36","683":"7e4d7491","734":"313e77b8"}[chunkId] + ".chunk.css";
};